export const SPORT_FAMILY_LEAGUES = Object.freeze({
  football: Object.freeze(["nfl", "nflp", "nflszn", "cfb", "cfl"]),
  basketball: Object.freeze([
    "nba", "nba2h", "wnba", "wnba1h", "cbb", "cbb1h", "cbb2h", "wcbb",
    "march", "ncaamb", "ncaawb", "nbasl", "fiba", "tbt", "unr", "allstar", "3pt"
  ]),
  baseball: Object.freeze(["mlb", "kbo", "wbc"])
});

const SPORT_FAMILY_BY_LEAGUE = Object.freeze(
  Object.entries(SPORT_FAMILY_LEAGUES).reduce((families, [family, leagues]) => {
    leagues.forEach((league) => {
      families[league] = family;
    });
    return families;
  }, {})
);

export const LIVE_HERO_FAMILY_BY_TYPE = Object.freeze({
  "live-football": "football",
  "live-basketball": "basketball",
  "live-baseball": "baseball"
});

export const getSportFamily = (league) => (
  SPORT_FAMILY_BY_LEAGUE[String(league || "").trim().toLowerCase()] || ""
);

export const getLiveHeroFamily = (type) => (
  LIVE_HERO_FAMILY_BY_TYPE[String(type || "").trim().toLowerCase()] || ""
);
